import { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router";
import API from "../../../services";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "./NewTicket.scss";
import Pagination from "../Pagination";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TokenPagination from "../TokenPagination";
import { useTranslation } from "../../../hooks/useTranslation";
import { connect } from "react-redux";
import { RootState } from "../../../models/RootState";

interface CustomerSupportProps {
    dynamicTextColors?: any;
}

const NewTicket: React.FC<CustomerSupportProps> = ({ dynamicTextColors }) => {
    const { t } = useTranslation();
    const pageTextColorClass = dynamicTextColors?.pageTextColorClass || "";
    const inputBoxTextColorClass = dynamicTextColors?.inputBoxTextColorClass || "";
    const buttonTextColorClass = dynamicTextColors?.buttonTextColorClass || "";
    const location = useLocation();
    const { details } = location.state || {};
    const [newTicket, setNewTicket] = useState<any>(false);
    const [newTicDes, setNewTicDes] = useState<any>("");
    const [newTicCat, setNewTicCat] = useState<any>("");
    const [refId, setRefId] = useState<any>("");
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState<any>(10);
    const navigate = useNavigate();
    const [count, setCount] = useState<any>(0);
    const [betNextPageToken, setBetNextPageToken] = useState("");
    const [betPageTokenHistory, setBetPageTokenHistory] = useState<string[]>([""]);
    const [bets, setBets] = useState<any>();
    const [transaction, setTransaction] = useState<any>();
    const [selectedBet, setSelectedBet] = useState<any>(null);
    const [selectedImages, setSelectedImages] = useState<File[]>([]);
    const [previews, setPreviews] = useState<string[]>([]);
    const [loadSubmit, setLoadSubmit] = useState<any>(false);
    const fileInputRef = useRef<HTMLInputElement | null>(null);


    const handleRowSelect = (row: any) => {
        setSelectedBet(row);
        if (newTicCat === "CASINO" || newTicCat === "SPORTS") {
            setRefId(row?.betId)
        } else if (newTicCat === "WITHDRAWAL" || newTicCat === "DEPOSIT" || newTicCat === "CRYPTO_WITHDRAWAL" || newTicCat === "CRYPTO_DEPOSIT") {
            setRefId(row?.referenceId)
        }
    };

    const resetBetPagination = () => {
        setBetPageTokenHistory([""]);
        setBetNextPageToken("");
    };

    const selectCat = (cat: any) => {
        setNewTicCat(cat);
        setNewTicDes("");
        setPage(1);
        setRowsPerPage(10);
        if (cat === "CASINO" || cat === "SPORTS") {
            resetBetPagination();
            getBetList(cat, "");
        } else if (cat === "WITHDRAWAL" || cat === "DEPOSIT" || cat === "CRYPTO_WITHDRAWAL" || cat === "CRYPTO_DEPOSIT") {
            loadMoreTransactions(cat);
        } else {
            setRefId("");
        }
    };

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        if (!e.target.files || e.target.files.length === 0) {
            console.log("No files selected"); // Debugging
            return;
        }

        const files = Array.from(e.target.files);
        console.log("Files selected:", files);

        const validFiles = files.filter(file => file.size < 1024 * 1024); // Ensure size < 1MB
        if (validFiles.length === 0) {
            toast.info(t("support.messages.onlyImagesLessThan1MBAllowed"));
            return;
        }

        setSelectedImages((prevImages) => [...prevImages, ...validFiles]);
        setPreviews((prevPreviews) => [
            ...prevPreviews,
            ...validFiles.map((file) => URL.createObjectURL(file)),
        ]);

        // Fix: Reinitialize file input to ensure event triggers on next selection
        resetFileInput();
    };

    const resetFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
            const newInput = fileInputRef.current.cloneNode(true) as HTMLInputElement;
            fileInputRef.current.replaceWith(newInput);
            fileInputRef.current = newInput;

            // Fix: Wrap handleImageChange inside an event listener conversion
            fileInputRef.current.addEventListener("change", (evt) => {
                handleImageChange(evt as unknown as React.ChangeEvent<HTMLInputElement>);
            });
        }
    };

    const removeImage = (index: number) => {
        setSelectedImages((prevImages) => prevImages.filter((_, i) => i !== index));
        setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    };




    if (!details) {
        return <div className={`${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{t("support.messages.noDetailsAvailable")}</div>;
    }

    const handleBackClick = () => {
        navigate(-1);
    };

    const loadMoreTransactions = async (cat: any) => {

        setLoading(true);
        try {
            const userKey = sessionStorage.getItem("userKey");
            const res = await API.post("/account/get-transactions", {
                userKey: userKey,
                page: page,
                pageSize: rowsPerPage,
                transactionType: cat
            });

            if (res.data.status === "RS_OK") {
                const data = res?.data?.transactions || [];
                setTransaction(data)
                if (page === 0 || page === 1) {
                    setCount(res?.data?.total);
                }
            } else {
                console.error("Error fetching transactions");
            }
        } catch (error) {
            console.error("Failed to load transactions", error);
        } finally {
            setLoading(false);
        }
    };

    const getBetList = async (cat: any, pageToken = "") => {
        setLoading(true);

        let response;
        try {
            response = await API.post(`/users/bet-list`, {
                category: cat,
                pageToken,
                pageSize: rowsPerPage,
            });
        } catch (e) {
            console.log(e);
            setLoading(false);
            return;
        }

        if (response.data.status !== "RS_OK") {
            navigate("/home");
            toast.error(response?.data?.errorDescription);
            setLoading(false);
            return;
        }

        setBets([]);
        if (response && response.data?.bets) {
            setBets(response?.data?.bets);
            setBetNextPageToken(response?.data?.nextPageToken || "");
        }
        setLoading(false);
    };

    const handleBetNextPage = () => {
        if (!betNextPageToken) return;
        setBetPageTokenHistory((prev) => [...prev, betNextPageToken]);
        getBetList(newTicCat, betNextPageToken);
    };

    const handleBetPrevPage = () => {
        if (betPageTokenHistory.length <= 1) return;
        const updatedHistory = betPageTokenHistory.slice(0, -1);
        const previousToken = updatedHistory[updatedHistory.length - 1] || "";
        setBetPageTokenHistory(updatedHistory);
        getBetList(newTicCat, previousToken);
    };

    const handleBetRowsPerPageChange = () => {
        resetBetPagination();
        getBetList(newTicCat, "");
    };

    const dateFormat = (time: any) => {
        const matchStartTime = new Date(time);

        const formattedStartTime = matchStartTime.toLocaleString("en-GB", {
            day: "numeric",
            month: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: false,
        });

        return formattedStartTime
    }

    const handleTicketsuccess = (row: any) => {
        navigate("/ticket-details", { state: { ticketId: row } });
    };

    const fileToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const result = reader.result as string;
                const base64 = result.includes(",") ? result.split(",")[1] : result;
                resolve(base64);
            };
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
        });
    };

    const handleSubmit = async () => {
        if (selectedImages.length === 0) {
            alert(t("support.pleaseSelectImagesBeforeSubmitting"));
            return;
        }

        // This helper is no longer used for API calls,
        // image upload is handled in createTicket via base64 payload.
    };


    const createTicket = async () => {

        setLoadSubmit(true);

        try {
            const images = await Promise.all(selectedImages.map((image) => fileToBase64(image)));
            const image_names = selectedImages.map((image) => image.name);
            const image_types = selectedImages.map((image) => image.type);

            const ticketData = {
                category: newTicCat,
                description: newTicDes,
                referenceID: refId,
            };

            const formData = new FormData();
            formData.append("ticketData", JSON.stringify(ticketData));
            formData.append("image", images.join(","));
            formData.append("image_names", image_names.join(","));
            formData.append("image_types", image_types.join(","));

            const response = await API.post(`/webapp/create-support-ticket`, formData);

            const data = response.data;
            if (data.status !== "RS_OK") {
                toast.error(`${data.errorDescription}`);
                return;
            } else {
                handleTicketsuccess(data?.ticketId);
            }
            setNewTicDes("");
            setNewTicCat("");
            setRefId("");
            setSelectedImages([]);
            setNewTicket(false);
            setSelectedBet({});
        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
        } finally {
            setLoadSubmit(false);
        }
    };


    const onClickDiv = () => {
        console.log("Entered Click");

    }

    return (
        <>
            <div className="flex flex-col px-3 mt-4 w-full pb-[7rem] py-[4rem] customer-support">
                <header className={`flex gap-3 items-center self-start text-base font-medium text-center mb-[0.5rem] w-full ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>
                    <div>
                        <div className="bg-inputbox-color flex p-1 mr-[0.25rem] rounded"
                            onClick={() => handleBackClick()}
                        >
                            <ArrowBackIcon
                                className={`aspect-square w-[18px] ${inputBoxTextColorClass} ${inputBoxTextColorClass === "dark-text" ? "text-black" : "text-white"}`}
                                style={{ width: '20px', height: '20px', color: inputBoxTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}
                            />
                        </div>
                    </div>
                    <h2 className="self-stretch my-auto">{t("support.createTicket")}</h2>
                </header>
                <div className="w-full mt-3 mb-3">
                    <select
                        className={`flex items-center justify-between w-full px-3 py-2 text-xs font-medium whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-border-color ${inputBoxTextColorClass} ${inputBoxTextColorClass === "dark-text" ? "text-black" : "text-white"}`}
                        style={{ color: inputBoxTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}
                        value={newTicCat} onChange={(e) => selectCat(e.target.value)}>
                        <option value="" disabled>
                            {t("support.selectCategory")}
                        </option>
                        {details?.map((option: any) => (
                            <option value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>

                {
                    (newTicCat === "CASINO" || newTicCat === "SPORTS") && bets && (
                        <>
                            {
                                bets?.length > 0 ? (<>
                                    <label className={`block mt-1 text-sm ${inputBoxTextColorClass} ${inputBoxTextColorClass === "dark-text" ? "text-gray-600" : "text-zinc-400"}`} style={{ color: inputBoxTextColorClass === "dark-text" ? "#666666" : "#A1A1AA" }}>{t("support.pleaseSelectBetFromTable")}</label>
                                    <div className="overflow-x-auto">
                                        <table className="min-w-full border-collapse user-table border-x mt-1">
                                            <thead>
                                                <tr>
                                                    <th className={`px-4 py-2 text-left border-b border-t ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>-</th>
                                                    <th className={`px-4 py-2 text-left border-b border-t ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{t("bets.status")}</th>
                                                    <th className={`px-4 py-2 text-left border-b border-t ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{t("bets.profitLoss")}</th>
                                                    <th className={`px-4 py-2 text-left border-b border-t ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{t("bets.date")}</th>
                                                    <th className={`px-4 py-2 text-left border-b border-t ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{t("bets.sport")}</th>
                                                    <th className={`px-4 py-2 text-left border-b border-t ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{t("bets.eventName")}</th>
                                                    <th className={`px-4 py-2 text-left border-b border-t ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{t("bets.marketName")}</th>
                                                    <th className={`px-4 py-2 text-left border-b border-t ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{t("bets.category")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bets?.map((row: any, index: number) => (
                                                    <tr key={index} className="border-b">
                                                        <td className={`p-2 ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>
                                                            <input
                                                                type="radio"
                                                                name="betSelection"
                                                                onChange={() => handleRowSelect(row)}
                                                                checked={selectedBet?.betId === row?.betId}
                                                            />
                                                        </td>
                                                        <td className={`p-2 ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{row?.status}</td>
                                                        <td
                                                            className={`p-2 ${row?.netAmout > 0
                                                                ? "text-green-500"
                                                                : row?.netAmout < 0
                                                                    ? "text-red-500"
                                                                    : pageTextColorClass === "dark-text"
                                                                        ? "text-black"
                                                                        : "text-white"
                                                                }`}
                                                            style={row?.netAmout === 0 || row?.netAmout === undefined ? { color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" } : undefined}
                                                        >
                                                            {row?.netAmout
                                                                ? row?.netAmout % 1 === 0
                                                                    ? row?.netAmout
                                                                    : row?.netAmout.toFixed(2)
                                                                : 0}
                                                        </td>
                                                        <td className={`px-2 py-2 ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{dateFormat(row?.betTime)}</td>
                                                        <td className={`p-2 ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{row?.sportName}</td>
                                                        <td className={`p-2 ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{row?.eventName}</td>
                                                        <td className={`p-2 ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{row?.marketName}</td>
                                                        <td className={`p-2 ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{row?.category}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <TokenPagination
                                        rowsPerPage={rowsPerPage}
                                        setRowsPerPage={setRowsPerPage}
                                        onNext={handleBetNextPage}
                                        onPrev={handleBetPrevPage}
                                        canGoPrev={betPageTokenHistory.length > 1}
                                        canGoNext={!!betNextPageToken}
                                        onRowsPerPageChange={handleBetRowsPerPageChange}
                                        dynamicTextColors={dynamicTextColors}
                                    />
                                </>) : (<>
                                    <div className={`block mt-1 text-sm ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{t("support.noBetsAvailableForCategory")}</div>
                                </>)
                            }
                        </>
                    )
                }

                {
                    (newTicCat === "WITHDRAWAL" || newTicCat === "DEPOSIT" || newTicCat === "CRYPTO_WITHDRAWAL" || newTicCat === "CRYPTO_DEPOSIT") && transaction && (
                        <>
                            {
                                transaction?.length > 0 ? (
                                    <>
                                        <label className={`block mt-1 text-sm ${inputBoxTextColorClass} ${inputBoxTextColorClass === "dark-text" ? "text-gray-600" : "text-zinc-400"}`} style={{ color: inputBoxTextColorClass === "dark-text" ? "#666666" : "#A1A1AA" }}>{t("support.pleaseSelectOptionFromTable")}</label>
                                        <div className="overflow-x-auto">
                                            <table className="min-w-full border-collapse user-table border-x mt-1">
                                                <thead>
                                                    <tr>
                                                        <th className={`px-4 py-2 text-left border-b border-t ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>-</th>
                                                        <th className={`px-4 py-2 text-left border-b border-t ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{t("common.amount")}</th>
                                                        <th className={`px-4 py-2 text-left border-b border-t ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{t("bets.time")}</th>
                                                        <th className={`px-4 py-2 text-left border-b border-t ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{t("bets.status")}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {transaction?.map((row: any, index: number) => (
                                                        <tr key={index} className="border-b">
                                                            <td className={`p-2 ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>
                                                                <input
                                                                    type="radio"
                                                                    name="betSelection"
                                                                    onChange={() => handleRowSelect(row)}
                                                                    checked={selectedBet?.referenceId === row?.referenceId}
                                                                />
                                                            </td>
                                                            <td className={`p-2 ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{row?.amount}</td>

                                                            <td className={`px-2 py-2 ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{dateFormat(row?.time)}</td>
                                                            <td className={`p-2 ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{row?.status}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <Pagination currentPage={page} setCurrentPage={setPage} setRowsPerPage={setRowsPerPage} rowsPerPage={rowsPerPage} eventsCount={count} callBackFunc={() => loadMoreTransactions(newTicCat)} dynamicTextColors={dynamicTextColors} />
                                    </>
                                ) : (<>
                                    <div className={`block mt-1 text-sm ${pageTextColorClass} ${pageTextColorClass === "dark-text" ? "text-black" : "text-white"}`} style={{ color: pageTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}>{t("support.noTransactionAvailableForCategory")}</div>
                                </>)
                            }
                        </>
                    )
                }

                <label
                    htmlFor="amount"
                    className={`block mt-3 text-sm ${inputBoxTextColorClass} ${inputBoxTextColorClass === "dark-text" ? "text-gray-600" : "text-zinc-400"}`}
                    style={{ color: inputBoxTextColorClass === "dark-text" ? "#666666" : "#A1A1AA" }}
                >
                    {t("support.description")}
                </label>
                <input
                    type="text"
                    className={`px-4 py-3 mt-2.5 mb-1 w-full text-sm font-medium placeholder:text-text-color whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-border-color focus:outline-none leading-[1.4rem] ${inputBoxTextColorClass} ${inputBoxTextColorClass === "dark-text" ? "text-black" : "text-white"}`}
                    style={{ color: inputBoxTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}
                    placeholder={t("support.enterYourIssue")}
                    value={newTicDes || ""}
                    onChange={(e) => setNewTicDes(e.target.value)}
                />
                {!newTicDes && (
                    <span className="text-sm text-orange-500">
                        {t("support.descriptionCannotBeEmpty")}
                    </span>
                )}

                <div>
                    <label className={`block mt-3 text-sm ${inputBoxTextColorClass} ${inputBoxTextColorClass === "dark-text" ? "text-gray-600" : "text-zinc-400"}`} style={{ color: inputBoxTextColorClass === "dark-text" ? "#666666" : "#A1A1AA" }}>{t("support.attachImage")}</label>
                    <label htmlFor="file-upload" className="block w-full mt-2.5 mb-3">
                        <input
                            id="file-upload"
                            ref={fileInputRef}
                            type="file"
                            accept="image/*"
                            // multiple
                            onChange={handleImageChange}
                            className="hidden"
                        />
                        <button
                            type="button"
                            onClick={() => fileInputRef.current?.click()}
                            className={`flex items-center justify-center w-full px-4 py-3 text-sm font-medium whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-border-color shadow-sm hover:bg-opacity-80 ${inputBoxTextColorClass} ${inputBoxTextColorClass === "dark-text" ? "text-black" : "text-white"}`}
                            style={{ color: inputBoxTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}
                        >
                            {t("support.chooseImage")}
                        </button>
                    </label>
                    <label className={`block text-xs ${inputBoxTextColorClass} ${inputBoxTextColorClass === "dark-text" ? "text-gray-600" : "text-zinc-400"}`} style={{ color: inputBoxTextColorClass === "dark-text" ? "#666666" : "#A1A1AA" }}>{t("support.onlyImagesLessThan1MB")}</label>
                    <label className={`block text-xs ${inputBoxTextColorClass} ${inputBoxTextColorClass === "dark-text" ? "text-gray-600" : "text-zinc-400"}`} style={{ color: inputBoxTextColorClass === "dark-text" ? "#666666" : "#A1A1AA" }}>{t("support.noteIfUnableToUpload")}</label>

                    {previews.length > 0 && (
                        <div className="grid grid-cols-3 gap-4 mt-2">
                            {previews.map((preview, index) => (
                                <div key={index} className="relative group">
                                    <img
                                        src={preview}
                                        alt={`Preview ${index}`}
                                        className="w-24 h-24 object-cover rounded-lg border border-border-color shadow-md"
                                    />
                                    <button
                                        onClick={() => removeImage(index)}
                                        className="absolute top-1 right-1 bg-red-600 text-white rounded-full w-5 h-5 text-xs flex items-center justify-center opacity-90 hover:opacity-100 transition"
                                    >
                                        ✕
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="flex justify-between mt-4">
                    <button
                        type="submit"
                        className={`p-2.5 w-[98%] text-sm bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem] ${buttonTextColorClass} ${buttonTextColorClass === "dark-text" ? "text-black" : "text-white"}`}
                        style={{ color: buttonTextColorClass === "dark-text" ? "#000000" : "#FFFFFF" }}
                        disabled={
                            !newTicCat ||
                            !newTicDes ||
                            ((newTicCat === "DEPOSIT" || newTicCat === "WITHDRAWAL" || newTicCat === "CRYPTO_DEPOSIT" || newTicCat === "CRYPTO_WITHDRAWAL") && !selectedBet) ||
                            loadSubmit
                        }
                        onClick={() => createTicket()}
                    >
                        {loadSubmit ? t("support.submitting") : t("common.submit")}
                    </button>
                </div>

                <div className="h-[200px] p-16"></div>
            </div>

        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    dynamicTextColors: state.userDetails?.dynamicTextColors,
});

export default connect(mapStateToProps)(NewTicket);